import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class Globals {
    accessType: string;
    errorMessage: string = '';
    public loginSuccess$ = new Subject<void>();

    constructor(private readonly http: HttpClient) { }

    public notifyLoginSuccess(): void {
        this.loginSuccess$.next();
    }

    public getUserInfo(): Observable<string> {
        var wait = new Subject<string>();
        if (this.accessType) {
            // We already have the accessType data, just return it right away!
            wait.next(this.accessType); // rxJs/Subject.next() is what signals that the Observable has completed 
        } else {
            // We haven't already fetched the accessType data from the server, go get it!
            //console.log("Fetching accessType from the server!");
            this.http.get<string>("/api/site/UserAccessType").subscribe(result => {
                this.accessType = result as string;
                wait.next(this.accessType);
            });
        }
        return wait;
    }

    public isLoggedIn(): boolean {
        var isLoggedIn = false;
        this.http.get<string>('/api/site/authenticated').subscribe(result => {
            const trimmedResult = result.replace(/"/g, '').trim();
            console.log(trimmedResult);
            if (trimmedResult === 'LoggedIn') {
                isLoggedIn = true;
            } else {
                isLoggedIn =  false;
            }
        });
        return isLoggedIn;
    }
   
}